<template>
    <gofix-card :title="section" fullContent class="gofixCardChecklist mb-0" classHeader="pl-25" collapse>
        <div class="gofixBasicTable">
            <div class="dataList">
                <b-table :tbody-tr-class="rowClass" :fields="fields" :responsive="true" :items="item.checklist_entries" fixed class="mb-0">
                    <template slot="input" slot-scope="row">
                        {{ row.item.input.data_type ? row.item.input.data_type : '-' }}
                    </template>
                    <template slot="value" slot-scope="row">
                        <template v-if="row.item.status != 'NA'">
                            <b-form-checkbox @input="getCheckListEntryValue(row.item)" v-if="!row.item.input.data_type || row.item.input.data_type === 'Checkbox'" :disabled="!isAllowEditEntryValue" v-model="row.item.input.value"></b-form-checkbox>
                            <gofix-form-input @change="getCheckListEntryValue(row.item)" class="m-0" label v-if="row.item.input.data_type === 'Free text'" :disabled="!isAllowEditEntryValue" v-model="row.item.input.value"></gofix-form-input>
                            <div class="d-flex align-items-center" v-if="row.item.input.data_type === 'Reading'">
                                <gofix-form-input-number 
                                @change="checkReadingTypeValidate(row.item)"
                                @input="resetCheckReadingTypeValidate(row.item)"
                                @focus="handleFocus(arguments[0], row.item)"
                                label class="m-0"
                                :includeThousandsSeparator="false"
                                allowNegative
                                :class="{ 'form-input--error': row.item.status === 'Filled' && !row.item.input.value }"
                                :disabled="!isAllowEditEntryValue"
                                v-model="row.item.input.value"></gofix-form-input-number>
                                <span class="ml-1 d-block nowrap" v-if="row.item.input.unit">{{row.item.input.unit}}</span>
                            </div>
                            <gofix-form-dropdown @input="getCheckListEntryValue(row.item)" class="m-0" label v-if="row.item.input.data_type === 'Dropdown'" :disabled="!isAllowEditEntryValue" v-model="row.item.input.value" :options="row.item.input.possible_value"
                            >
                                <template slot="gofixInput:dropdown:option" slot-scope="option">
                                    <span v-b-tooltip.hover.top :title="option.label" v-html="option.label"></span>
                                </template>
                            </gofix-form-dropdown>
                        </template>
                        <template v-else>
                            <span class="na-status">--</span>
                        </template>
                    </template>
                    <template slot="status" slot-scope="row">
                        <gofix-form-dropdown 
                            :clearable="false" class="m-0" 
                            label 
                            @change="changeChecklistEntryStatus(row.item)" 
                            v-model="row.item.status" 
                            :disabled="!isAllowEditEntryStatus"
                            :options="checkListEntryStatus">
                        </gofix-form-dropdown>
                    </template>
                    <template slot="remark_id" slot-scope="row">
                        <div class="checklist-remark-box justify-content-between">
                            <div @click="editFollowUp(row.item)" class="checklist-remark-box-item d-flex">
                                <b-form-checkbox class="job-list-checkbox" disabled :checked="Number(row.item.remark_id) > 0 ? true : false"></b-form-checkbox>
                                <span class="d-inline pl-13">{{row.item.follow_up ? row.item.follow_up.description:''}}</span>
                            </div>
                            <div v-if="row.item.follow_up && row.item.follow_up.attachments" class="photosThumb checklist-remark-box-item mt-0 mb-0">
                                <viewer-image :images="row.item.follow_up.attachments">
                                    <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                        <ul class="list-thumb">
                                            <template v-for="(item,key) in row.item.follow_up.attachments">
                                                <li v-if="key < 2" v-bind:key="key">
                                                    <img v-auth-image="item.url.medium" alt  src="img/loading.gif"/>
                                                </li>
                                                <li v-if="key >= 2 && key <= (images.length-2)" v-bind:key="key" class="d-none">
                                                    <img v-auth-image="item.url.medium" alt  src="img/loading.gif"/>
                                                </li>
                                                <template v-if="key == 2 && images.length > 2">
                                                    <div class="attachmentsColumn pl-0" :key="key">
                                                        <div class="item-content bg-transparent pd-0">
                                                            <img class="image-viewer" v-auth-image="images[images.length-1].url.original"  src="img/loading.gif">
                                                            <span class="checklist-photo-custom checklist-remark-box-item pd-0">{{ '+' + (images.length - 2) }}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </ul>
                                    </template>
                                </viewer-image>
                            </div>
                        </div>
                    </template>
                    <template slot="follow_up" slot-scope="row">
                        <template v-if="row.item.entry_issue_sources && row.item.entry_issue_sources.issue_id">
                            <p class="mb-13">
                                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.138462 5.46154C0.0461539 5.36923 0 5.23077 0 5.13846C0 5.04615 0.0461539 4.90769 0.138462 4.81538L0.784615 4.16923C0.969231 3.98461 1.24615 3.98461 1.43077 4.16923L1.47692 4.21538L4.01538 6.93846C4.10769 7.03077 4.24615 7.03077 4.33846 6.93846L10.5231 0.523075H10.5692C10.7538 0.338459 11.0308 0.338459 11.2154 0.523075L11.8615 1.16923C12.0462 1.35384 12.0462 1.63077 11.8615 1.81538L4.47692 9.47692C4.38462 9.56923 4.29231 9.61538 4.15385 9.61538C4.01538 9.61538 3.92308 9.56923 3.83077 9.47692L0.230769 5.6L0.138462 5.46154Z" fill="#F05600" />
                                </svg>
                            </p>
                            <router-link target="_blank" class="text-dark" :to="`/v2/issue-register/${row.item.entry_issue_sources.issue_id}`">
                                <span class="text-decoration-underline">{{ `Issue.Register.${row.item.entry_issue_sources.issue_id}` }}</span>
                            </router-link>
                        </template>
                        <span v-else>
                            <span class="cursor-pointer" @click="showModalAddIssue(row.item)">
                                <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                </svg>
                            </span>
                        </span>
                    </template>
                </b-table>
            </div>
        </div>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modal.issue.open">
            <div class="center">Do you want to create <strong>issue register</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modal.issue.open = false">No</b-button>
                <b-button class="custom-btn" @click="showPriority">Yes</b-button>
            </b-button-group>
        </b-modal>
        <priority :loading="modal.sla.loading" :service-category-id="modal.sla.service_category_id" @raise-issue="raiseIssue" v-model="modal.sla.open"></priority>
    </gofix-card>
</template>

<script>
import { mapGetters } from "vuex";
const ViewImg = () => import("../plugins/ViewImg.vue")
const ViewerImage = () => import('../plugins/ViewerImage.vue')
const Priority = () => import('./modal_priority.vue')
    export default {
        name: 'checklist-entry-item',
        components: {
            ViewerImage,
            ViewImg,
            Priority
        },
        props: {
            item: {
                type: Object,
                default: () => {}
            },
            section: {
                type: String,
                default: null
            }
        },
        data() {
            return{
                fields: [
                    {
                        key: 'sequence',
                        label: 'Number',
                        thStyle: 'width: 132px',
                        thClass: 'pl-25',
                        tdClass: 'pl-25',
                    },
                    {
                        key: 'name',
                        label: 'Service Description',
                        thStyle: 'width: 240px'
                    },
                    {
                        key: 'input',
                        label: 'Value Type',
                        thStyle: 'width: 150px'
                    },
                    {
                        key: 'value',
                        label: 'Value',
                        thStyle: 'width: 150px'
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        thStyle: 'width: 130px'
                    },
                    {
                        key: 'remark_id',
                        label: 'Remarks',
                        thStyle: 'width: 175px',
                    },
                    {
                        key: 'follow_up',
                        label: 'Follow Up',
                        thStyle: 'width: 150px',
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    }
                ],
                checkListEntryStatus:[
                    'Filled',
                    'Unfilled',
                    'NA'
                ],
                checkListEntryUpdate:[],
                loading:false,
                modal: {
                    issue: {
                        open: false,
                        preset_actions: null,
                        checklistId: null
                    },
                    sla: {
                        open: false,
                        loading: false,
                        service_category_id: null
                    },
                },
                timer: {
                    issue: null
                }
            }
        },
        computed: {
            ...mapGetters({
                Item: "JobController/Item",
            }),
            isAllowEditEntryRemark() {
                if(!this.Item || !this.Item.editing_of_checklist_action || !this.Item.editing_of_checklist_action.is_allow_edit_entry_remark) return false;
                return true;
            },
            isAllowEditEntryStatus() {
                if(!this.Item || !this.Item.editing_of_checklist_action || !this.Item.editing_of_checklist_action.is_allow_edit_entry_status) return false;
                return true;
            },
            isAllowEditEntryValue() {
                if(!this.Item || !this.Item.editing_of_checklist_action || !this.Item.editing_of_checklist_action.is_allow_edit_entry_value) return false;
                return true;
            }   
        },
        created() {},
        methods: {
            rowClass(item, type){
                // if(item && item.hasOwnProperty('is_check_threshold') && item.is_check_threshold == true){
                //     if(item.input && item.input.data_type && item.input.data_type === "Reading"){
                //         if(item.input.value != null) {
                //             let value = parseFloat(item.input.value);
                //             const low_threshold = item.input.low_threshold ? item.input.low_threshold : 0;
                //             const high_threshold = item.input.high_threshold ? item.input.high_threshold : 0;
                //             if(value < low_threshold || high_threshold < value) {
                //                 return 'row-outside-value';
                //             }
                //         }
                //     }
                // }

                if(item && item.hasOwnProperty('is_output_highlighted') && item.is_output_highlighted == true){
                    if(item.input && item.input.data_type && item.input.data_type === "Reading" && item.is_output_highlighted){
                        return 'row-outside-value';
                    }
                }
                return;
            },
            handleFocus (value, item) {
                item.value_old = value;
                item.output_old = item.output;
                item.is_output_highlighted_old = item.is_output_highlighted;
                this.$emit('inputType', true)
            },
            resetCheckReadingTypeValidate(item) {
                if(item.hasOwnProperty('is_check_threshold') && item.is_check_threshold) item.is_check_threshold = false
            },
            async getCheckListEntryValue(val){
                this.$emit('updateCheckListEntries', { val:val, from_status:false});
            },
            async editFollowUp(checklistEntry){
                if(!this.isAllowEditEntryRemark) return;
                this.$emit('selectChecklistEntry', checklistEntry)
            },
            async checkReadingTypeValidate(item){
                let result = await this.getMinMax(item);
                
                // let value = await parseFloat(item.input.value);
                // const low_threshold = item.input.low_threshold ? item.input.low_threshold : 0;
                // const high_threshold = item.input.high_threshold ? item.input.high_threshold : 0;
                if(result.is_output_highlighted){
                    await this.$bvModal.msgBoxConfirm('Your value exceeds the threshold. Are you sure to keep the record?', {
                        title: 'Warning!',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'OK',
                        cancelTitle: 'CANCEL',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true,
                        id: "msgConfirm"
                    })
                    .then(value => {
                        if(value){
                            item.input.value = parseFloat(item.input.value);
                            item.is_output_highlighted = result.is_output_highlighted;
                            item.output = result.output;
                        } else{
                            item.input.value = item.value_old ? item.value_old : null;
                            item.is_output_highlighted = item.is_output_highlighted_old;
                            item.output = item.output_old;
                        }
                    })
                } else {
                    item.is_output_highlighted = result.is_output_highlighted;
                    item.output = result.output;
                }
                this.getCheckListEntryValue(item);
            },
            async getMinMax(item) {
                // let threshold = {
                //     min: parseFloat(item.low_threshold),
                //     max: parseFloat(item.high_threshold)
                // }
                let data = {};
                //if(item.calculated) {
                    //let request = this.parseDatatoSave();
                    await this.$store.dispatch("JobController/getCheckListCalculated", {
                        id: item.id,
                        data: {
                            input: item.input
                        },
                        //content_checklist: JSON.stringify(request.checklists.content_checklist)
                    }).then(result => {
                        data = Object.assign(data, result);
                    });
                //}
                return data;
            },
            async changeChecklistEntryStatus(item){
                switch (item.status) {
                    case 'Filled':
                        if(!item.input.value){
                            if(item.input.data_type === 'Checkbox'){
                                item.input.value = true;
                            } 
                            else{
                                this.$alertNotification('Please enter checklist entries value when the status Filled!','danger');
                            }
                        }
                        break;
                    case 'Unfilled':
                        item.input.value = null;
                        break;
                    case 'NA':
                        item.input.value = null;
                        break;
                }
                this.$emit('updateCheckListEntries',{val:item,from_status:true});
            },
            showModalAddIssue(item){
                if(!this.Item || !this.Item.editing_of_issue_action || !this.Item.editing_of_issue_action.is_allow_edit_status) return false;
                this.modal.issue.checklistId = item.id;
                this.modal.issue.preset_actions = item.preset_actions;
                this.modal.issue.open = true;
            },
            addIssue(sla_id){
                if (this.timer.issue) {
                    clearTimeout(this.timer.issue);
                    this.timer.issue = null;
                }
                this.timer.issue = setTimeout(() => {
                    this.modal.issue.loading = true;
                    this.$store.dispatch("CheckListController/checklistEntriesToCreateIssue", {
                        id: this.modal.issue.checklistId,
                        sla_id: sla_id,
                        // preset_actions: this.modal.issue.preset_actions
                    })
                        .then((result) => {
                            this.modal.sla.loading = false;
                            this.modal.sla.open = false;
                            this.$emit('reloadChecklist')
                        })
                        .catch((error) => {
                            this.modal.sla.loading = false;
                        });
                }, 200);
            },
            showPriority() {
                this.modal.issue.open = false;
                this.modal.sla.service_category_id = this.Item.service_category_id;
                this.modal.sla.open  = true;
            },
            raiseIssue(sla_id) {
                this.modal.sla.loading   = true;
                this.addIssue(sla_id);
            },

        }
    }
</script>
